import { useInfiniteQuery } from "@tanstack/react-query";
import catalogAPIs from "../api/catalogAPIs";

export const useGetAllCatalogs = ({ limit = 18, sort = "", search = "", isArchivefilter = false ,createdBy, designCount, startDate, endDate,}) => {
  return useInfiniteQuery({
    queryKey: ["catalogData", { limit: limit, sortBy: sort, search: search, isArchive: isArchivefilter ,createdBy, designCount, startDate, endDate,}],
    queryFn: ({ pageParam = 1 }) => catalogAPIs.getAllCatalogs({ pageParam, queryKey: ["catalogData", { limit: limit, sortBy: sort, search: search, isArchive: isArchivefilter ,createdBy, designCount, startDate, endDate,}] }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage < lastPage.totalPage) {
        return lastPage.nextPage + 1;
      }
      return undefined;
    },
    cacheTime: 200000,
    staleTime: 200000,
    refetchOnWindowFocus: true,
  });
};
